import { rest } from 'utils';

export default {
  login: ({ email, password }) => rest.get({
    baseUrl: 'reseller',
    url: 'contracts',
    headers: {
      Authorization: `Basic ${btoa(`${email}:${password}`)}`,
    },
    addContract: false,
    secure: false,
  }),
  getContracts: () => rest.get({
    baseUrl: 'reseller',
    url: 'contracts',
    addContract: false,
  }),
};
